(() => {
  const body = document.body;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const cards = '.product-card,.jc-product-tile,.lc-display,.lc-card,.snapshot-card,.pillar-card,.capability-overview,.capability-focus,.metric-card,.profile-product-card,.feature-list li';
  const reveals = `${cards},.section-heading,.profile-section-heading,.lc-family-heading,.lc-spec-panel,.step,.cta-band`;
  const seen = new WeakSet();
  const groups = new WeakMap();
  let paused = false;
  let frame = 0;
  let target = null;
  let point = null;
  const canTrack = () => fine.matches && !reduced.matches && !paused && !document.hidden;
  const stopTracking = () => {
    cancelAnimationFrame(frame);
    frame = 0;
    if (target) {
      target.style.removeProperty('--jc-x');
      target.style.removeProperty('--jc-y');
    }
    target = null;
    point = null;
  };
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target: el, isIntersecting}) => {
      if (!isIntersecting) return;
      el.classList.remove('jc-pending');
      revealObserver.unobserve(el);
    });
  }, {threshold: .06, rootMargin: '0px 0px 32px 0px'}) : null;
  const atmosphereObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target: el, isIntersecting}) => { el.dataset.inView = String(isIntersecting); });
  }) : null;
  function syncMotion() {
    body.dataset.motion = paused || reduced.matches ? 'paused' : 'running';
    body.dataset.pageHidden = String(document.hidden);
    document.querySelectorAll('.jc-motion-control').forEach(control => {
      control.hidden = reduced.matches;
      control.textContent = paused ? 'Resume motion' : 'Pause motion';
      control.setAttribute('aria-pressed', String(paused));
    });
    if (!canTrack()) stopTracking();
    if (paused || reduced.matches) {
      document.querySelectorAll('.jc-pending').forEach(el => {
        el.classList.remove('jc-pending');
        revealObserver?.unobserve(el);
      });
    }
  }
  function enhance(scope = document) {
    scope.querySelectorAll('.desktop-nav a,.mobile-menu a').forEach(a => {
      if (new URL(a.href, location.href).pathname === location.pathname) a.setAttribute('aria-current', 'page');
    });
    scope.querySelectorAll(cards).forEach(el => {
      if (el.hasAttribute('data-jc-card')) return;
      el.setAttribute('data-jc-card', '');
      const light = document.createElement('span');
      light.className = 'jc-card-light';
      light.setAttribute('aria-hidden', 'true');
      el.append(light);
    });
    scope.querySelectorAll('.jc-atmosphere').forEach(el => {
      if (el.hasAttribute('data-in-view')) return;
      el.dataset.inView = atmosphereObserver ? 'false' : 'true';
      atmosphereObserver?.observe(el);
    });
    scope.querySelectorAll(reveals).forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (!revealObserver || reduced.matches || paused || el.closest('.hero,.lc-hero,.product-carousel-track,.legal-content') || el.getBoundingClientRect().top < innerHeight) return;
      const index = groups.get(el.parentElement) || 0;
      groups.set(el.parentElement, index + 1);
      el.style.setProperty('--jc-delay', `${Math.min(index % 3, 2) * 70}ms`);
      el.classList.add('jc-reveal','jc-pending');
      revealObserver.observe(el);
    });
    syncMotion();
  }
  // Event-driven: one frame at most per pointer update; no continuous tracking loop.
  document.addEventListener('pointermove', event => {
    if (!canTrack() || event.pointerType !== 'mouse') return;
    const next = event.target.closest('[data-jc-card]');
    if (next !== target) { stopTracking(); target = next; }
    if (!target) return;
    point = {x: event.clientX, y: event.clientY};
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!target?.isConnected || !canTrack() || !point) return;
      const rect = target.getBoundingClientRect();
      target.style.setProperty('--jc-x', `${point.x - rect.left}px`);
      target.style.setProperty('--jc-y', `${point.y - rect.top}px`);
    });
  }, {passive: true});
  document.addEventListener('pointerout', event => {
    if (!event.relatedTarget || (target && !target.contains(event.relatedTarget))) stopTracking();
  }, {passive: true});
  document.addEventListener('scroll', stopTracking, {passive: true, capture: true});
  document.addEventListener('click', event => {
    if (!event.target.closest('.jc-motion-control')) return;
    paused = !paused;
    syncMotion();
  });
  document.addEventListener('visibilitychange', syncMotion);
  reduced.addEventListener('change', syncMotion);
  fine.addEventListener('change', syncMotion);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.jc-atmosphere,.jc-reveal').forEach(el => {
      atmosphereObserver?.unobserve(el);
      revealObserver?.unobserve(el);
    });
    stopTracking();
  });
  enhance();
})();
